var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "cardContainer" },
    _vm._l(_vm.displayedCards, function (card, i) {
      return _c(
        "div",
        { key: card.CCid },
        [
          _c("card-list-item", {
            attrs: { card: card, "is-selected": card === _vm.selectedCard },
            on: {
              click: function ($event) {
                return _vm.toggleCard(card)
              },
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }